onLoad(($) => {
  const nodes = $('#JS-image-upload-list');

  if (!nodes.length) return;
  // Skip auto-append behavior if the container explicitly disables it (used by proposals form)
  const disableAutoAdd = nodes.data('disableAutoAdd') === true || nodes.attr('data-disable-auto-add') === 'true';
  if (disableAutoAdd) return;

  var image_field = $('.image-upload-field').first();
  var raw_name = $(image_field).attr('name') || 'ticket_files';
  var base_name = raw_name.replace(/\[\]+$/, '');
  var array_name = base_name + '[]';
  $(image_field).attr('name', array_name);
  var idRemove = 0
  var removeButton = '<button class="btn remove" style="color: Tomato;"><i class="fas fa-trash danger"></i></button>'
  $(image_field).wrap('<div class=upload-wrapper></div>');
  $('.upload-wrapper').append('<button type="button" class="btn refreshthis" style="color: Tomato;"><i class="fas fa-trash danger"></i></button>');

  $('.refreshthis').on('click', function () {
    $('.upload-wrapper input').val('');
  });

  var addAnotherFile = function () {
    idRemove++;
    var new_image_field = $(image_field).clone();
    $(new_image_field).attr('name', array_name);
    $(new_image_field).appendTo('#JS-image-upload-list');
    $(new_image_field).val('').wrap(`<div class=upload-wrapper-${idRemove}></div>`);

    var upload_wrapper = $(`.upload-wrapper-${idRemove}`);
    $(upload_wrapper).append(removeButton);

    $('.remove').on('click', function () {
      $(this).parent().remove();
    });
  };

  $("#JS-image-upload-list").on('change', function () {
    $(addAnotherFile)
  });
});
